import { Action } from '@ngrx/store';
import { BackupTranslationInterface } from 'app/site-settings/models/backup-translation.model';

import { SiteSettingActionType } from './site-setings-action-type.enum';

export class LoadBackupTranslate implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadBackupTranslate;

  public readonly payload: any = undefined;
}

export class LoadBackupTranslateCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadBackupTranslateCompleted;

  constructor(public readonly payload: BackupTranslationInterface) { }
}

export class LoadBackupTranslateFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadBackupTranslateFailed;

  constructor(public readonly payload: string) { }
}
export class UpdateBackupTranslate implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBackupTranslate;

  constructor(public readonly payload: BackupTranslationInterface[]) {}
}

export class UpdateBackupTranslateCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBackupTranslateCompleted;

  constructor(public readonly payload: BackupTranslationInterface) {}
}

export class UpdateBackupTranslateFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateBackupTranslateFailed;

  constructor(public readonly payload: string) { }
}
